// mparle-search-overlay.js
// Predictive search via Shopify's Section Rendering API. Geen client-side
// templating: alle product-HTML wordt server-side door Liquid gerenderd
// (auto-escaped) en in de overlay geïnjecteerd via DOMParser.
(function () {
  const overlay = document.querySelector('[data-mp-search]');
  if (!overlay) return;

  const input = overlay.querySelector('[data-mp-search-input]');
  const host = overlay.querySelector('[data-mp-search-host]');
  const popular = overlay.querySelector('[data-mp-search-popular]');
  const closeBtn = overlay.querySelector('[data-mp-search-close]');

  const DEBOUNCE_MS = 200;
  const MIN_CHARS = 2;
  let timer = null;
  let inflight = null;

  function open() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.removeAttribute('inert');
    document.body.classList.add('mp-no-scroll');
    setTimeout(() => input?.focus(), 100);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('inert', '');
    document.body.classList.remove('mp-no-scroll');
  }

  function resetResults() {
    host.replaceChildren();
    if (popular) popular.style.display = '';
  }

  async function search(q) {
    if (inflight) inflight.abort();
    const ctrl = new AbortController();
    inflight = ctrl;
    const url = `/search/suggest?q=${encodeURIComponent(q)}&section_id=mparle-search-results&resources[type]=product&resources[limit]=4`;
    try {
      const res = await fetch(url, { signal: ctrl.signal });
      if (!res.ok) return;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-mp-search-results]');
      if (!fresh) return;
      if (popular) popular.style.display = 'none';
      const existing = host.querySelector('[data-mp-search-results]');
      if (existing) existing.replaceWith(fresh);
      else host.appendChild(fresh);
    } catch (err) {
      if (err.name !== 'AbortError') console.error('predictive search failed', err);
    } finally {
      if (inflight === ctrl) inflight = null;
    }
  }

  input?.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < MIN_CHARS) {
      if (inflight) inflight.abort();
      resetResults();
      return;
    }
    timer = setTimeout(() => search(q), DEBOUNCE_MS);
  });

  document.querySelectorAll('[data-mp-search-open]').forEach((btn) =>
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    })
  );

  closeBtn?.addEventListener('click', close);

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });
})();
